import loadable from '@loadable/component';

const ArrowRight = loadable(() => import(/* webpackChunkName: "arrow-right" */ './ArrowRight'));

export default ArrowRight;
